import {
  DisplayName32zbf48594hse as DisplayName,
  DoesNotNeedLabel294wkz4b87zo as DoesNotNeedLabel,
} from './Annotations.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import {
  ConditionAndSerializershp9a696fdxf as ConditionAndSerializer,
  ConditionOrSerializerwwh3agum1kpd as ConditionOrSerializer,
  ConditionNotSerializer3ey7lovzblniv as ConditionNotSerializer,
  ConditionEqualSerializer3n9q0cnonfztj as ConditionEqualSerializer,
  ConditionNotEqualSerializer20gzmmwowd8le as ConditionNotEqualSerializer,
  ConditionInsideSerializer2dufbf53611bw as ConditionInsideSerializer,
  ConditionNotInsideSerializer91ftvtxrrk34 as ConditionNotInsideSerializer,
  ConditionGreaterThanSerializer277dsnyavrmc9 as ConditionGreaterThanSerializer,
  ConditionLessThanSerializer1od1ld42d54u4 as ConditionLessThanSerializer,
  ConditionGreaterThanOrEqualSerializerd3i5m1nwtoi7 as ConditionGreaterThanOrEqualSerializer,
  ConditionLessThanOrEqualSerializer1vvxz52khnx5 as ConditionLessThanOrEqualSerializer,
  ConditionIntBitsClearSerializer_getInstance2os59x4h1vpfb as ConditionIntBitsClearSerializer_getInstance,
  ConditionIntBitsSetSerializer_getInstance1wuh0zi8t27wz as ConditionIntBitsSetSerializer_getInstance,
  ConditionIntBitsAnyClearSerializer_getInstance39t9786jt668y as ConditionIntBitsAnyClearSerializer_getInstance,
  ConditionIntBitsAnySetSerializer_getInstance1w3q3n2h75sx1 as ConditionIntBitsAnySetSerializer_getInstance,
  ConditionListAllElementsSerializer3sj93hfexg66j as ConditionListAllElementsSerializer,
  ConditionListAnyElementsSerializer2q4myqn5rkmn as ConditionListAnyElementsSerializer,
  ConditionListSizesEqualsSerializer1qwggu7wvog2x as ConditionListSizesEqualsSerializer,
  ConditionSetAllElementsSerializer2x6jg9l2e18xo as ConditionSetAllElementsSerializer,
  ConditionSetAnyElementsSerializer1k22fozvgrp6w as ConditionSetAnyElementsSerializer,
  ConditionSetSizesEqualsSerializerlxoe42ppkrqz as ConditionSetSizesEqualsSerializer,
  ConditionExistsSerializer2mmkbd3iu2pth as ConditionExistsSerializer,
  ConditionSerializer21tf3x2n3amih as ConditionSerializer,
  ConditionIfNotNullSerializer3cz0ngjdcqx1i as ConditionIfNotNullSerializer,
} from './ConditionSerialization.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
  DoubleSerializer_getInstance3da4hv5ndgjlx as DoubleSerializer_getInstance,
  IntSerializer_getInstance2q7s8kvk1il5u as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  GeoCoordinateGeoJsonSerializer_getInstance27i54kiunnp5w as GeoCoordinateGeoJsonSerializer_getInstance,
  GeoCoordinatemhej4memzolm as GeoCoordinate,
} from '../GeoCoordinate.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { toList383f556t1dixk as toList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  first58ocm7j58k3q as first,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { IsRawStringxv018dzbtx4q as IsRawString } from '../StringAlts.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { Companion_instanceyc5x9yqxshdb as Companion_instance } from './TextQuery.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  RegexOption_IGNORE_CASE_getInstance1e6t23ud6ux7i as RegexOption_IGNORE_CASE_getInstance,
  Regexxgw0gjiagf4z as Regex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.w3k_1.f2();
}
function Condition$Never$_anonymous__ewqlu4() {
  var tmp = Never_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [new (DisplayName())('None')];
  return ObjectSerializer().e1c('Never', tmp, tmp$ret$2);
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.x3k_1.f2();
}
function Condition$Always$_anonymous__1v2vb3() {
  var tmp = Always_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [new (DisplayName())('All')];
  return ObjectSerializer().e1c('Always', tmp, tmp$ret$2);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionAndSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionOrSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionNotSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionEqualSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  return Companion_instance_3;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionNotEqualSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_3() {
  return Companion_instance_4;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionInsideSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  return Companion_instance_5;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionNotInsideSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_5() {
  return Companion_instance_6;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionGreaterThanSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_6() {
  return Companion_instance_7;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionLessThanSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_7() {
  return Companion_instance_8;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionGreaterThanOrEqualSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_8() {
  return Companion_instance_9;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionLessThanOrEqualSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_9() {
  return Companion_instance_10;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_10() {
  return Companion_instance_11;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('StringContains', this, 2);
        tmp0_serialDesc.a1b('value', false);
        tmp0_serialDesc.b1b(new (DoesNotNeedLabel())());
        tmp0_serialDesc.a1b('ignoreCase', true);
        this.z3o_1 = tmp0_serialDesc;
      }
      a3p(encoder, value) {
        var tmp0_desc = this.z3o_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.b3p_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.c3p_1 === false)) {
          tmp1_output.s14(tmp0_desc, 1, value.c3p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.a3p(encoder, value instanceof StringContains() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.z3o_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return StringContains().d3p(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.z3o_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      constructor() {
        Companion_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('StringContains', null, 2);
        tmp0_serialDesc.a1b('value', false);
        tmp0_serialDesc.a1b('ignoreCase', true);
        this.y3k_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer_0().g3p(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_12;
function Companion_getInstance_11() {
  if (Companion_instance_12 === VOID)
    new (Companion_11())();
  return Companion_instance_12;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      static h3p() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('StringContains', $this, 2);
        tmp0_serialDesc.a1b('value', false);
        tmp0_serialDesc.a1b('ignoreCase', true);
        $this.e3p_1 = tmp0_serialDesc;
        return $this;
      }
      i3p(encoder, value) {
        var tmp0_desc = this.e3p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.j3p_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.k3p_1 === false)) {
          tmp1_output.s14(tmp0_desc, 1, value.k3p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.i3p(encoder, value instanceof RawStringContains() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.e3p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return RawStringContains().l3p(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.e3p_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.f3p_1];
      }
      static g3p(typeSerial0) {
        var $this = this.h3p();
        $this.f3p_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_13;
function Companion_getInstance_12() {
  return Companion_instance_13;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('GeoDistance', this, 3);
        tmp0_serialDesc.a1b('value', false);
        tmp0_serialDesc.a1b('greaterThanKilometers', true);
        tmp0_serialDesc.a1b('lessThanKilometers', true);
        this.m3p_1 = tmp0_serialDesc;
      }
      n3p(encoder, value) {
        var tmp0_desc = this.m3p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, GeoCoordinateGeoJsonSerializer_getInstance(), value.o3p_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !equals(value.p3p_1, 0.0)) {
          tmp1_output.y14(tmp0_desc, 1, value.p3p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !equals(value.q3p_1, 100000.0)) {
          tmp1_output.y14(tmp0_desc, 2, value.q3p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.n3p(encoder, value instanceof GeoDistance() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.m3p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0.0;
        var tmp6_local2 = 0.0;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, GeoCoordinateGeoJsonSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.t13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.t13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.x13(tmp0_desc, 0, GeoCoordinateGeoJsonSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.t13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.t13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return GeoDistance().r3p(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.m3p_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [GeoCoordinateGeoJsonSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_1())();
  return $serializer_instance_0;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('FullTextSearch', null, 3);
        tmp0_serialDesc.a1b('value', false);
        tmp0_serialDesc.a1b('requireAllTermsPresent', true);
        tmp0_serialDesc.a1b('levenshteinDistance', true);
        this.z3k_1 = tmp0_serialDesc;
      }
      b2j(typeSerial0) {
        return $serializer_2().u3p(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_14;
function Companion_getInstance_13() {
  if (Companion_instance_14 === VOID)
    new (Companion_13())();
  return Companion_instance_14;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      static v3p() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('FullTextSearch', $this, 3);
        tmp0_serialDesc.a1b('value', false);
        tmp0_serialDesc.b1b(new (DoesNotNeedLabel())());
        tmp0_serialDesc.a1b('requireAllTermsPresent', true);
        tmp0_serialDesc.a1b('levenshteinDistance', true);
        $this.s3p_1 = tmp0_serialDesc;
        return $this;
      }
      w3p(encoder, value) {
        var tmp0_desc = this.s3p_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.x3p_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.y3p_1 === true)) {
          tmp1_output.s14(tmp0_desc, 1, value.y3p_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.z3p_1 === 2)) {
          tmp1_output.v14(tmp0_desc, 2, value.z3p_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.w3p(encoder, value instanceof FullTextSearch() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.s3p_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.q13(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.q13(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return FullTextSearch().a3q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      az() {
        return this.s3p_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance()];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.t3p_1];
      }
      static u3p(typeSerial0) {
        var $this = this.v3p();
        $this.t3p_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      k2a() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_15;
function Companion_getInstance_14() {
  return Companion_instance_15;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('RegexMatches', this, 2);
        tmp0_serialDesc.a1b('pattern', false);
        tmp0_serialDesc.b1b(new (DoesNotNeedLabel())());
        tmp0_serialDesc.a1b('ignoreCase', true);
        this.b3q_1 = tmp0_serialDesc;
      }
      c3q(encoder, value) {
        var tmp0_desc = this.b3q_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.d3q_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.e3q_1 === false)) {
          tmp1_output.s14(tmp0_desc, 1, value.e3q_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.c3q(encoder, value instanceof RegexMatches() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.b3q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp7_input = decoder.l13(tmp0_desc);
        if (tmp7_input.a14()) {
          tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.n13(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.n13(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp7_input.m13(tmp0_desc);
        return RegexMatches().g3q(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.b3q_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).s1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_3())();
  return $serializer_instance_1;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      k2a() {
        return ConditionIntBitsClearSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_16;
function Companion_getInstance_15() {
  return Companion_instance_16;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      k2a() {
        return ConditionIntBitsSetSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_17;
function Companion_getInstance_16() {
  return Companion_instance_17;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      k2a() {
        return ConditionIntBitsAnyClearSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_18;
function Companion_getInstance_17() {
  return Companion_instance_18;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      k2a() {
        return ConditionIntBitsAnySetSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_19;
function Companion_getInstance_18() {
  return Companion_instance_19;
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      a3l(typeSerial0) {
        return new (ConditionListAllElementsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.a3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_20;
function Companion_getInstance_19() {
  return Companion_instance_20;
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      a3l(typeSerial0) {
        return new (ConditionListAnyElementsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.a3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_21;
function Companion_getInstance_20() {
  return Companion_instance_21;
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      a3l(typeSerial0) {
        return new (ConditionListSizesEqualsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.a3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_22;
function Companion_getInstance_21() {
  return Companion_instance_22;
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      a3l(typeSerial0) {
        return new (ConditionSetAllElementsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.a3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_23;
function Companion_getInstance_22() {
  return Companion_instance_23;
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      a3l(typeSerial0) {
        return new (ConditionSetAnyElementsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.a3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_24;
function Companion_getInstance_23() {
  return Companion_instance_24;
}
var CompanionClass_24;
function Companion_24() {
  if (CompanionClass_24 === VOID) {
    class $ {
      a3l(typeSerial0) {
        return new (ConditionSetSizesEqualsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.a3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_24 = $;
  }
  return CompanionClass_24;
}
var Companion_instance_25;
function Companion_getInstance_24() {
  return Companion_instance_25;
}
var CompanionClass_25;
function Companion_25() {
  if (CompanionClass_25 === VOID) {
    class $ {
      b3l(typeSerial0) {
        return new (ConditionExistsSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_25 = $;
  }
  return CompanionClass_25;
}
var Companion_instance_26;
function Companion_getInstance_25() {
  return Companion_instance_26;
}
var CompanionClass_26;
function Companion_26() {
  if (CompanionClass_26 === VOID) {
    class $ {
      constructor() {
        Companion_instance_27 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('OnKey', null, 2);
        tmp0_serialDesc.a1b('key', false);
        tmp0_serialDesc.a1b('condition', false);
        this.c3l_1 = tmp0_serialDesc;
      }
      b3l(typeSerial0) {
        return $serializer_4().j3q(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b3l(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_26 = $;
  }
  return CompanionClass_26;
}
var Companion_instance_27;
function Companion_getInstance_26() {
  if (Companion_instance_27 === VOID)
    new (Companion_26())();
  return Companion_instance_27;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      static k3q() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('OnKey', $this, 2);
        tmp0_serialDesc.a1b('key', false);
        tmp0_serialDesc.a1b('condition', false);
        $this.h3q_1 = tmp0_serialDesc;
        return $this;
      }
      l3q(encoder, value) {
        var tmp0_desc = this.h3q_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.a15(tmp0_desc, 0, value.m3q_1);
        tmp1_output.c15(tmp0_desc, 1, new (ConditionSerializer())(this.i3q_1), value.n3q_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.l3q(encoder, value instanceof OnKey() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.h3q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.i3q_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ConditionSerializer())(this.i3q_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return OnKey().o3q(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.h3q_1;
      }
      r1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), new (ConditionSerializer())(this.i3q_1)];
      }
      s1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.i3q_1];
      }
      static j3q(typeSerial0) {
        var $this = this.k3q();
        $this.i3q_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var CompanionClass_27;
function Companion_27() {
  if (CompanionClass_27 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionIfNotNullSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_27 = $;
  }
  return CompanionClass_27;
}
var Companion_instance_28;
function Companion_getInstance_27() {
  return Companion_instance_28;
}
var NeverClass;
function Never() {
  if (NeverClass === VOID) {
    class $ extends Condition() {
      static p3q() {
        Never_instance = null;
        var $this = this.q3q();
        Never_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.w3k_1 = lazy(tmp_0, Condition$Never$_anonymous__ewqlu4);
        return $this;
      }
      l3h(on) {
        return false;
      }
      r3q(on) {
        return this.l3h((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        return 'false';
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
      hashCode() {
        return 912844817;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Never()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Never', VOID, VOID, [Condition(), SerializerFactory()], VOID, VOID, {0: Never_getInstance});
    NeverClass = $;
  }
  return NeverClass;
}
var Never_instance;
function Never_getInstance() {
  if (Never_instance === VOID)
    Never().p3q();
  return Never_instance;
}
var AlwaysClass;
function Always() {
  if (AlwaysClass === VOID) {
    class $ extends Condition() {
      static s3q() {
        Always_instance = null;
        var $this = this.q3q();
        Always_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.x3k_1 = lazy(tmp_0, Condition$Always$_anonymous__1v2vb3);
        return $this;
      }
      l3h(on) {
        return true;
      }
      r3q(on) {
        return this.l3h((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        return 'true';
      }
      k2a() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      f1c(typeParamsSerializers) {
        return this.k2a();
      }
      hashCode() {
        return -2132269782;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Always()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Always', VOID, VOID, [Condition(), SerializerFactory()], VOID, VOID, {0: Always_getInstance});
    AlwaysClass = $;
  }
  return AlwaysClass;
}
var Always_instance;
function Always_getInstance() {
  if (Always_instance === VOID)
    Always().s3q();
  return Always_instance;
}
var AndClass;
function And() {
  if (AndClass === VOID) {
    class $ extends Condition() {
      static u3q(conditions) {
        var $this = this.q3q();
        $this.t3q_1 = conditions;
        return $this;
      }
      static v3q(conditions) {
        return this.u3q(toList(conditions));
      }
      r3q(on) {
        var tmp0 = this.t3q_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!element.r3q(on)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      toString() {
        return joinToString(this.t3q_1, ' && ', '(', ')');
      }
      hashCode() {
        return hashCode(this.t3q_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof And()))
          return false;
        if (!equals(this.t3q_1, other.t3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'And', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    AndClass = $;
  }
  return AndClass;
}
var OrClass;
function Or() {
  if (OrClass === VOID) {
    class $ extends Condition() {
      static x3q(conditions) {
        var $this = this.q3q();
        $this.w3q_1 = conditions;
        return $this;
      }
      static y3q(conditions) {
        return this.x3q(toList(conditions));
      }
      r3q(on) {
        var tmp0 = this.w3q_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.r3q(on)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      toString() {
        return joinToString(this.w3q_1, ' || ', '(', ')');
      }
      hashCode() {
        return hashCode(this.w3q_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Or()))
          return false;
        if (!equals(this.w3q_1, other.w3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Or', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    OrClass = $;
  }
  return OrClass;
}
var NotClass;
function Not() {
  if (NotClass === VOID) {
    class $ extends Condition() {
      static a3r(condition) {
        var $this = this.q3q();
        $this.z3q_1 = condition;
        return $this;
      }
      r3q(on) {
        return !this.z3q_1.r3q(on);
      }
      toString() {
        return '!(' + toString(this.z3q_1) + ')';
      }
      hashCode() {
        return this.z3q_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Not()))
          return false;
        if (!this.z3q_1.equals(other.z3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Not', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    NotClass = $;
  }
  return NotClass;
}
var EqualClass;
function Equal() {
  if (EqualClass === VOID) {
    class $ extends Condition() {
      static c3r(value) {
        var $this = this.q3q();
        $this.b3r_1 = value;
        return $this;
      }
      r3q(on) {
        return equals(on, this.b3r_1);
      }
      toString() {
        return ' == ' + toString_0(this.b3r_1);
      }
      hashCode() {
        return this.b3r_1 == null ? 0 : hashCode(this.b3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Equal()))
          return false;
        if (!equals(this.b3r_1, other.b3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Equal', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    EqualClass = $;
  }
  return EqualClass;
}
var NotEqualClass;
function NotEqual() {
  if (NotEqualClass === VOID) {
    class $ extends Condition() {
      static e3r(value) {
        var $this = this.q3q();
        $this.d3r_1 = value;
        return $this;
      }
      r3q(on) {
        return !equals(on, this.d3r_1);
      }
      toString() {
        return ' != ' + toString_0(this.d3r_1);
      }
      hashCode() {
        return this.d3r_1 == null ? 0 : hashCode(this.d3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotEqual()))
          return false;
        if (!equals(this.d3r_1, other.d3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NotEqual', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    NotEqualClass = $;
  }
  return NotEqualClass;
}
var InsideClass;
function Inside() {
  if (InsideClass === VOID) {
    class $ extends Condition() {
      static g3r(values) {
        var $this = this.q3q();
        $this.f3r_1 = values;
        return $this;
      }
      r3q(on) {
        return this.f3r_1.t1(on);
      }
      toString() {
        return ' in ' + toString(this.f3r_1);
      }
      hashCode() {
        return hashCode(this.f3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Inside()))
          return false;
        if (!equals(this.f3r_1, other.f3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Inside', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    InsideClass = $;
  }
  return InsideClass;
}
var NotInsideClass;
function NotInside() {
  if (NotInsideClass === VOID) {
    class $ extends Condition() {
      static i3r(values) {
        var $this = this.q3q();
        $this.h3r_1 = values;
        return $this;
      }
      r3q(on) {
        return !this.h3r_1.t1(on);
      }
      toString() {
        return ' !in ' + toString(this.h3r_1);
      }
      hashCode() {
        return hashCode(this.h3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotInside()))
          return false;
        if (!equals(this.h3r_1, other.h3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NotInside', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    NotInsideClass = $;
  }
  return NotInsideClass;
}
var GreaterThanClass;
function GreaterThan() {
  if (GreaterThanClass === VOID) {
    class $ extends Condition() {
      static k3r(value) {
        var $this = this.q3q();
        $this.j3r_1 = value;
        return $this;
      }
      l3r(on) {
        return compareTo(on, this.j3r_1) > 0;
      }
      r3q(on) {
        return this.l3r((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' > ' + toString(this.j3r_1);
      }
      hashCode() {
        return hashCode(this.j3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GreaterThan()))
          return false;
        if (!equals(this.j3r_1, other.j3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GreaterThan', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
    GreaterThanClass = $;
  }
  return GreaterThanClass;
}
var LessThanClass;
function LessThan() {
  if (LessThanClass === VOID) {
    class $ extends Condition() {
      static n3r(value) {
        var $this = this.q3q();
        $this.m3r_1 = value;
        return $this;
      }
      l3r(on) {
        return compareTo(on, this.m3r_1) < 0;
      }
      r3q(on) {
        return this.l3r((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' < ' + toString(this.m3r_1);
      }
      hashCode() {
        return hashCode(this.m3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LessThan()))
          return false;
        if (!equals(this.m3r_1, other.m3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LessThan', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    LessThanClass = $;
  }
  return LessThanClass;
}
var GreaterThanOrEqualClass;
function GreaterThanOrEqual() {
  if (GreaterThanOrEqualClass === VOID) {
    class $ extends Condition() {
      static p3r(value) {
        var $this = this.q3q();
        $this.o3r_1 = value;
        return $this;
      }
      l3r(on) {
        return compareTo(on, this.o3r_1) >= 0;
      }
      r3q(on) {
        return this.l3r((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' >= ' + toString(this.o3r_1);
      }
      hashCode() {
        return hashCode(this.o3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GreaterThanOrEqual()))
          return false;
        if (!equals(this.o3r_1, other.o3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GreaterThanOrEqual', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    GreaterThanOrEqualClass = $;
  }
  return GreaterThanOrEqualClass;
}
var LessThanOrEqualClass;
function LessThanOrEqual() {
  if (LessThanOrEqualClass === VOID) {
    class $ extends Condition() {
      static r3r(value) {
        var $this = this.q3q();
        $this.q3r_1 = value;
        return $this;
      }
      l3r(on) {
        return compareTo(on, this.q3r_1) <= 0;
      }
      r3q(on) {
        return this.l3r((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' <= ' + toString(this.q3r_1);
      }
      hashCode() {
        return hashCode(this.q3r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LessThanOrEqual()))
          return false;
        if (!equals(this.q3r_1, other.q3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LessThanOrEqual', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    LessThanOrEqualClass = $;
  }
  return LessThanOrEqualClass;
}
var StringContainsClass;
function StringContains() {
  if (StringContainsClass === VOID) {
    class $ extends Condition() {
      static s3r(value, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var $this = this.q3q();
        $this.b3p_1 = value;
        $this.c3p_1 = ignoreCase;
        return $this;
      }
      t3r(on) {
        return contains(on, this.b3p_1, this.c3p_1);
      }
      r3q(on) {
        return this.t3r((!(on == null) ? typeof on === 'string' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.contains(' + this.b3p_1 + ', ' + this.c3p_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.b3p_1);
        result = imul(result, 31) + getBooleanHashCode(this.c3p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StringContains()))
          return false;
        if (!(this.b3p_1 === other.b3p_1))
          return false;
        if (!(this.c3p_1 === other.c3p_1))
          return false;
        return true;
      }
      static d3p(seen0, value, ignoreCase, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().z3o_1);
        }
        var $this = this.q3q();
        $this.b3p_1 = value;
        if (0 === (seen0 & 2))
          $this.c3p_1 = false;
        else
          $this.c3p_1 = ignoreCase;
        return $this;
      }
    }
    initMetadataForClass($, 'StringContains', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    StringContainsClass = $;
  }
  return StringContainsClass;
}
var RawStringContainsClass;
function RawStringContains() {
  if (RawStringContainsClass === VOID) {
    class $ extends Condition() {
      static u3r(value, ignoreCase) {
        Companion_getInstance_11();
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var $this = this.q3q();
        $this.j3p_1 = value;
        $this.k3p_1 = ignoreCase;
        return $this;
      }
      v3r(on) {
        return contains(on.h3n(), this.j3p_1, this.k3p_1);
      }
      r3q(on) {
        return this.v3r((!(on == null) ? isInterface(on, IsRawString()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.contains(' + this.j3p_1 + ', ' + this.k3p_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.j3p_1);
        result = imul(result, 31) + getBooleanHashCode(this.k3p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RawStringContains()))
          return false;
        if (!(this.j3p_1 === other.j3p_1))
          return false;
        if (!(this.k3p_1 === other.k3p_1))
          return false;
        return true;
      }
      static l3p(seen0, value, ignoreCase, serializationConstructorMarker) {
        Companion_getInstance_11();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_11().y3k_1);
        }
        var $this = this.q3q();
        $this.j3p_1 = value;
        if (0 === (seen0 & 2))
          $this.k3p_1 = false;
        else
          $this.k3p_1 = ignoreCase;
        return $this;
      }
    }
    initMetadataForClass($, 'RawStringContains', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
    RawStringContainsClass = $;
  }
  return RawStringContainsClass;
}
var GeoDistanceClass;
function GeoDistance() {
  if (GeoDistanceClass === VOID) {
    class $ extends Condition() {
      w3r(on) {
        var containsLower = this.p3p_1;
        var containsUpper = this.q3p_1;
        var containsArg = on.w3l(this.o3p_1);
        return containsLower <= containsArg ? containsArg <= containsUpper : false;
      }
      r3q(on) {
        return this.w3r(on instanceof GeoCoordinate() ? on : THROW_CCE());
      }
      toString() {
        return '.distanceToKilometers(value) in ' + this.p3p_1 + '..' + this.q3p_1;
      }
      hashCode() {
        var result = this.o3p_1.hashCode();
        result = imul(result, 31) + getNumberHashCode(this.p3p_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.q3p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GeoDistance()))
          return false;
        if (!this.o3p_1.equals(other.o3p_1))
          return false;
        if (!equals(this.p3p_1, other.p3p_1))
          return false;
        if (!equals(this.q3p_1, other.q3p_1))
          return false;
        return true;
      }
      static r3p(seen0, value, greaterThanKilometers, lessThanKilometers, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().m3p_1);
        }
        var $this = this.q3q();
        $this.o3p_1 = value;
        if (0 === (seen0 & 2))
          $this.p3p_1 = 0.0;
        else
          $this.p3p_1 = greaterThanKilometers;
        if (0 === (seen0 & 4))
          $this.q3p_1 = 100000.0;
        else
          $this.q3p_1 = lessThanKilometers;
        return $this;
      }
    }
    initMetadataForClass($, 'GeoDistance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    GeoDistanceClass = $;
  }
  return GeoDistanceClass;
}
var FullTextSearchClass;
function FullTextSearch() {
  if (FullTextSearchClass === VOID) {
    class $ extends Condition() {
      static x3r(value, requireAllTermsPresent, levenshteinDistance) {
        Companion_getInstance_13();
        requireAllTermsPresent = requireAllTermsPresent === VOID ? true : requireAllTermsPresent;
        levenshteinDistance = levenshteinDistance === VOID ? 2 : levenshteinDistance;
        var $this = this.q3q();
        $this.x3p_1 = value;
        $this.y3p_1 = requireAllTermsPresent;
        $this.z3p_1 = levenshteinDistance;
        return $this;
      }
      r3q(on) {
        return Companion_instance.y3r(this.x3p_1).c3s(toString_0(on), this.z3p_1);
      }
      toString() {
        return '.fullTextSearch(' + this.x3p_1 + ', ' + this.y3p_1 + ', ' + this.z3p_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.x3p_1);
        result = imul(result, 31) + getBooleanHashCode(this.y3p_1) | 0;
        result = imul(result, 31) + this.z3p_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FullTextSearch()))
          return false;
        if (!(this.x3p_1 === other.x3p_1))
          return false;
        if (!(this.y3p_1 === other.y3p_1))
          return false;
        if (!(this.z3p_1 === other.z3p_1))
          return false;
        return true;
      }
      static a3q(seen0, value, requireAllTermsPresent, levenshteinDistance, serializationConstructorMarker) {
        Companion_getInstance_13();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_13().z3k_1);
        }
        var $this = this.q3q();
        $this.x3p_1 = value;
        if (0 === (seen0 & 2))
          $this.y3p_1 = true;
        else
          $this.y3p_1 = requireAllTermsPresent;
        if (0 === (seen0 & 4))
          $this.z3p_1 = 2;
        else
          $this.z3p_1 = levenshteinDistance;
        return $this;
      }
    }
    initMetadataForClass($, 'FullTextSearch', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_13});
    FullTextSearchClass = $;
  }
  return FullTextSearchClass;
}
var RegexMatchesClass;
function RegexMatches() {
  if (RegexMatchesClass === VOID) {
    class $ extends Condition() {
      t3r(on) {
        return this.f3q_1.rh(on);
      }
      r3q(on) {
        return this.t3r((!(on == null) ? typeof on === 'string' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.contains(Regex(' + this.d3q_1 + '), ' + this.e3q_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.d3q_1);
        result = imul(result, 31) + getBooleanHashCode(this.e3q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RegexMatches()))
          return false;
        if (!(this.d3q_1 === other.d3q_1))
          return false;
        if (!(this.e3q_1 === other.e3q_1))
          return false;
        return true;
      }
      static g3q(seen0, pattern, ignoreCase, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().b3q_1);
        }
        var $this = this.q3q();
        $this.d3q_1 = pattern;
        if (0 === (seen0 & 2))
          $this.e3q_1 = false;
        else
          $this.e3q_1 = ignoreCase;
        var tmp = $this;
        var tmp_0;
        if ($this.e3q_1) {
          tmp_0 = setOf(RegexOption_IGNORE_CASE_getInstance());
        } else {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        }
        tmp.f3q_1 = Regex().ph($this.d3q_1, tmp_0);
        return $this;
      }
    }
    initMetadataForClass($, 'RegexMatches', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    RegexMatchesClass = $;
  }
  return RegexMatchesClass;
}
var IntBitsClearClass;
function IntBitsClear() {
  if (IntBitsClearClass === VOID) {
    class $ extends Condition() {
      static e3s(mask) {
        var $this = this.q3q();
        $this.d3s_1 = mask;
        return $this;
      }
      f3s(on) {
        return (on & this.d3s_1) === 0;
      }
      r3q(on) {
        return this.f3s((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsClear(' + toString_1(this.d3s_1, 16) + ')';
      }
      hashCode() {
        return this.d3s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsClear()))
          return false;
        if (!(this.d3s_1 === other.d3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsClear', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsClearSerializer_getInstance});
    IntBitsClearClass = $;
  }
  return IntBitsClearClass;
}
var IntBitsSetClass;
function IntBitsSet() {
  if (IntBitsSetClass === VOID) {
    class $ extends Condition() {
      static h3s(mask) {
        var $this = this.q3q();
        $this.g3s_1 = mask;
        return $this;
      }
      f3s(on) {
        return (on & this.g3s_1) === this.g3s_1;
      }
      r3q(on) {
        return this.f3s((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsSet(' + toString_1(this.g3s_1, 16) + ')';
      }
      hashCode() {
        return this.g3s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsSet()))
          return false;
        if (!(this.g3s_1 === other.g3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsSet', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsSetSerializer_getInstance});
    IntBitsSetClass = $;
  }
  return IntBitsSetClass;
}
var IntBitsAnyClearClass;
function IntBitsAnyClear() {
  if (IntBitsAnyClearClass === VOID) {
    class $ extends Condition() {
      static j3s(mask) {
        var $this = this.q3q();
        $this.i3s_1 = mask;
        return $this;
      }
      f3s(on) {
        return (on & this.i3s_1) < this.i3s_1;
      }
      r3q(on) {
        return this.f3s((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsAnyClear(' + toString_1(this.i3s_1, 16) + ')';
      }
      hashCode() {
        return this.i3s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsAnyClear()))
          return false;
        if (!(this.i3s_1 === other.i3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsAnyClear', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsAnyClearSerializer_getInstance});
    IntBitsAnyClearClass = $;
  }
  return IntBitsAnyClearClass;
}
var IntBitsAnySetClass;
function IntBitsAnySet() {
  if (IntBitsAnySetClass === VOID) {
    class $ extends Condition() {
      static l3s(mask) {
        var $this = this.q3q();
        $this.k3s_1 = mask;
        return $this;
      }
      f3s(on) {
        return (on & this.k3s_1) > 0;
      }
      r3q(on) {
        return this.f3s((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsAnySet(' + toString_1(this.k3s_1, 16) + ')';
      }
      hashCode() {
        return this.k3s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsAnySet()))
          return false;
        if (!(this.k3s_1 === other.k3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsAnySet', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsAnySetSerializer_getInstance});
    IntBitsAnySetClass = $;
  }
  return IntBitsAnySetClass;
}
var ListAllElementsClass;
function ListAllElements() {
  if (ListAllElementsClass === VOID) {
    class $ extends Condition() {
      static n3s(condition) {
        var $this = this.q3q();
        $this.m3s_1 = condition;
        return $this;
      }
      o3s(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!this.m3s_1.r3q(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      r3q(on) {
        return this.o3s((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.all { it' + toString(this.m3s_1) + ' }';
      }
      hashCode() {
        return this.m3s_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListAllElements()))
          return false;
        if (!this.m3s_1.equals(other.m3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListAllElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_19});
    ListAllElementsClass = $;
  }
  return ListAllElementsClass;
}
var ListAnyElementsClass;
function ListAnyElements() {
  if (ListAnyElementsClass === VOID) {
    class $ extends Condition() {
      static q3s(condition) {
        var $this = this.q3q();
        $this.p3s_1 = condition;
        return $this;
      }
      o3s(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (this.p3s_1.r3q(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      r3q(on) {
        return this.o3s((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.any { it' + toString(this.p3s_1) + ' }';
      }
      hashCode() {
        return this.p3s_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListAnyElements()))
          return false;
        if (!this.p3s_1.equals(other.p3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListAnyElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
    ListAnyElementsClass = $;
  }
  return ListAnyElementsClass;
}
var ListSizesEqualsClass;
function ListSizesEquals() {
  if (ListSizesEqualsClass === VOID) {
    class $ extends Condition() {
      static s3s(count) {
        var $this = this.q3q();
        $this.r3s_1 = count;
        return $this;
      }
      o3s(on) {
        return on.p1() === this.r3s_1;
      }
      r3q(on) {
        return this.o3s((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.size == ' + this.r3s_1;
      }
      hashCode() {
        return this.r3s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListSizesEquals()))
          return false;
        if (!(this.r3s_1 === other.r3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListSizesEquals', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_21});
    ListSizesEqualsClass = $;
  }
  return ListSizesEqualsClass;
}
var SetAllElementsClass;
function SetAllElements() {
  if (SetAllElementsClass === VOID) {
    class $ extends Condition() {
      static u3s(condition) {
        var $this = this.q3q();
        $this.t3s_1 = condition;
        return $this;
      }
      v3s(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!this.t3s_1.r3q(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      r3q(on) {
        return this.v3s((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.all { it' + toString(this.t3s_1) + ' }';
      }
      hashCode() {
        return this.t3s_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAllElements()))
          return false;
        if (!this.t3s_1.equals(other.t3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetAllElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_22});
    SetAllElementsClass = $;
  }
  return SetAllElementsClass;
}
var SetAnyElementsClass;
function SetAnyElements() {
  if (SetAnyElementsClass === VOID) {
    class $ extends Condition() {
      static x3s(condition) {
        var $this = this.q3q();
        $this.w3s_1 = condition;
        return $this;
      }
      v3s(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (this.w3s_1.r3q(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      r3q(on) {
        return this.v3s((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.any { it' + toString(this.w3s_1) + ' }';
      }
      hashCode() {
        return this.w3s_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAnyElements()))
          return false;
        if (!this.w3s_1.equals(other.w3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetAnyElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_23});
    SetAnyElementsClass = $;
  }
  return SetAnyElementsClass;
}
var SetSizesEqualsClass;
function SetSizesEquals() {
  if (SetSizesEqualsClass === VOID) {
    class $ extends Condition() {
      static z3s(count) {
        var $this = this.q3q();
        $this.y3s_1 = count;
        return $this;
      }
      v3s(on) {
        return on.p1() === this.y3s_1;
      }
      r3q(on) {
        return this.v3s((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.size == ' + this.y3s_1;
      }
      hashCode() {
        return this.y3s_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetSizesEquals()))
          return false;
        if (!(this.y3s_1 === other.y3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetSizesEquals', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_24});
    SetSizesEqualsClass = $;
  }
  return SetSizesEqualsClass;
}
var ExistsClass;
function Exists() {
  if (ExistsClass === VOID) {
    class $ extends Condition() {
      static b3t(key) {
        var $this = this.q3q();
        $this.a3t_1 = key;
        return $this;
      }
      c3t(on) {
        return on.n3(this.a3t_1);
      }
      r3q(on) {
        return this.c3t((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.containsKey(' + this.a3t_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.a3t_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Exists()))
          return false;
        if (!(this.a3t_1 === other.a3t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Exists', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_25});
    ExistsClass = $;
  }
  return ExistsClass;
}
var OnKeyClass;
function OnKey() {
  if (OnKeyClass === VOID) {
    class $ extends Condition() {
      c3t(on) {
        var tmp;
        if (on.n3(this.m3q_1)) {
          var tmp_0 = on.p3(this.m3q_1);
          tmp = this.n3q_1.r3q((tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE());
        } else {
          tmp = false;
        }
        return tmp;
      }
      r3q(on) {
        return this.c3t((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '[' + this.m3q_1 + ']' + toString(this.n3q_1);
      }
      hashCode() {
        var result = getStringHashCode(this.m3q_1);
        result = imul(result, 31) + this.n3q_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OnKey()))
          return false;
        if (!(this.m3q_1 === other.m3q_1))
          return false;
        if (!this.n3q_1.equals(other.n3q_1))
          return false;
        return true;
      }
      static o3q(seen0, key, condition, serializationConstructorMarker) {
        Companion_getInstance_26();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_26().c3l_1);
        }
        var $this = this.q3q();
        $this.m3q_1 = key;
        $this.n3q_1 = condition;
        return $this;
      }
    }
    initMetadataForClass($, 'OnKey', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_26});
    OnKeyClass = $;
  }
  return OnKeyClass;
}
var OnFieldClass;
function OnField() {
  if (OnFieldClass === VOID) {
    class $ extends Condition() {
      static f3t(key, condition) {
        var $this = this.q3q();
        $this.d3t_1 = key;
        $this.e3t_1 = condition;
        return $this;
      }
      g3t(on) {
        return this.e3t_1.r3q(this.d3t_1.k2j(on));
      }
      r3q(on) {
        return this.g3t((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        var tmp;
        var tmp_0 = this.e3t_1;
        if (tmp_0 instanceof OnField()) {
          tmp = this.d3t_1.i20() + '.' + toString(this.e3t_1);
        } else {
          tmp = this.d3t_1.i20() + toString(this.e3t_1);
        }
        return tmp;
      }
      hashCode() {
        var result = hashCode(this.d3t_1);
        result = imul(result, 31) + this.e3t_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OnField()))
          return false;
        if (!equals(this.d3t_1, other.d3t_1))
          return false;
        if (!this.e3t_1.equals(other.e3t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OnField');
    OnFieldClass = $;
  }
  return OnFieldClass;
}
var IfNotNullClass;
function IfNotNull() {
  if (IfNotNullClass === VOID) {
    class $ extends Condition() {
      static i3t(condition) {
        var $this = this.q3q();
        $this.h3t_1 = condition;
        return $this;
      }
      j3t(on) {
        return !(on == null) && this.h3t_1.r3q(on);
      }
      r3q(on) {
        return this.j3t((on == null ? true : !(on == null)) ? on : THROW_CCE());
      }
      toString() {
        return '? ' + toString(this.h3t_1);
      }
      hashCode() {
        return this.h3t_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IfNotNull()))
          return false;
        if (!this.h3t_1.equals(other.h3t_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IfNotNull', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_27});
    IfNotNullClass = $;
  }
  return IfNotNullClass;
}
var CompanionClass_28;
function Companion_28() {
  if (CompanionClass_28 === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (ConditionSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_28 = $;
  }
  return CompanionClass_28;
}
var Companion_instance_29;
function Companion_getInstance_28() {
  return Companion_instance_29;
}
var ConditionClass;
function Condition() {
  if (ConditionClass === VOID) {
    class $ {
      static q3q() {
        return createThis(this);
      }
      hashCode() {
        throw NotImplementedError().qd();
      }
      equals(other) {
        throw NotImplementedError().qd();
      }
      r3q(on) {
        throw NotImplementedError().qd();
      }
    }
    initMetadataForClass($, 'Condition', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_28});
    ConditionClass = $;
  }
  return ConditionClass;
}
function orNotNull(_this__u8e3s4, conditions) {
  var list = filterNotNull(toList(conditions));
  switch (list.p1()) {
    case 0:
      return Never_getInstance();
    case 1:
      return first(list);
    default:
      return Or().x3q(list);
  }
}
function and(_this__u8e3s4, other) {
  return And().u3q(listOf([_this__u8e3s4, other]));
}
function andNotNull(_this__u8e3s4, conditions) {
  var list = filterNotNull(toList(conditions));
  switch (list.p1()) {
    case 0:
      return Always_getInstance();
    case 1:
      return first(list);
    default:
      return And().u3q(list);
  }
}
function or(_this__u8e3s4, other) {
  return Or().x3q(listOf([_this__u8e3s4, other]));
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_4 = new (Companion_3())();
Companion_instance_5 = new (Companion_4())();
Companion_instance_6 = new (Companion_5())();
Companion_instance_7 = new (Companion_6())();
Companion_instance_8 = new (Companion_7())();
Companion_instance_9 = new (Companion_8())();
Companion_instance_10 = new (Companion_9())();
Companion_instance_11 = new (Companion_10())();
Companion_instance_13 = new (Companion_12())();
Companion_instance_15 = new (Companion_14())();
Companion_instance_16 = new (Companion_15())();
Companion_instance_17 = new (Companion_16())();
Companion_instance_18 = new (Companion_17())();
Companion_instance_19 = new (Companion_18())();
Companion_instance_20 = new (Companion_19())();
Companion_instance_21 = new (Companion_20())();
Companion_instance_22 = new (Companion_21())();
Companion_instance_23 = new (Companion_22())();
Companion_instance_24 = new (Companion_23())();
Companion_instance_25 = new (Companion_24())();
Companion_instance_26 = new (Companion_25())();
Companion_instance_28 = new (Companion_27())();
Companion_instance_29 = new (Companion_28())();
//endregion
//region block: exports
export {
  Always as Always2zzuixun3eunx,
  And as And3abx79zpqd7r8,
  Equal as Equal3ow85705ftxfk,
  Exists as Exists42par4hiiuoz,
  FullTextSearch as FullTextSearch2rlpx79w2gy53,
  GeoDistance as GeoDistancewu4mc8tux7go,
  GreaterThanOrEqual as GreaterThanOrEqualhh0t265tpr4s,
  GreaterThan as GreaterThan2wk647zyknocd,
  IfNotNull as IfNotNull13ixxkuz43ozs,
  Inside as Inside39cktoz42t35z,
  IntBitsAnyClear as IntBitsAnyClear2gpw670obzya9,
  IntBitsAnySet as IntBitsAnySetbikmbua6gn9s,
  IntBitsClear as IntBitsClear24ickx5y259jy,
  IntBitsSet as IntBitsSet382z2e9l593cy,
  LessThanOrEqual as LessThanOrEqual3qv1kgxmn1wy,
  LessThan as LessThankb2oaehgm1o9,
  ListAllElements as ListAllElements37v3iva2v7nna,
  ListAnyElements as ListAnyElements3qzxczea8im7z,
  ListSizesEquals as ListSizesEqualsndkuh8n9g3vb,
  Never as Never1qlvyqx796jr1,
  NotEqual as NotEqual12qw5zp9xbgnd,
  NotInside as NotInside2db9qer39ktxf,
  Not as Not1k5e2vlrceq68,
  OnField as OnField23al9ljlbymf9,
  OnKey as OnKeymlp0tbupd08v,
  Or as Or3lq77uaxl3wr0,
  RawStringContains as RawStringContains2aah1oj1an1a9,
  RegexMatches as RegexMatches3bf1egw4rhxym,
  SetAllElements as SetAllElements1q4mlxrpjpkix,
  SetAnyElements as SetAnyElements2ckwqq78ogad0,
  SetSizesEquals as SetSizesEqualsooda5aj1zhty,
  StringContains as StringContains38lplog8dg7er,
  Condition as Conditionuclxcm24fzd9,
  andNotNull as andNotNull1zuhbghcdslbi,
  and as andvtrcuje7baox,
  orNotNull as orNotNull29zbfwadzwyme,
  or as or1ww9501dfiqpb,
  Always_getInstance as Always_getInstancecs10mhg5aot2,
  Companion_instance_0 as Companion_instance3axtksx96wcm8,
  Companion_instance_29 as Companion_instancek13g6rikuawd,
  Companion_instance_3 as Companion_instance3ak5m32y5x4a2,
  Companion_instance_26 as Companion_instance393e5hna3az6,
  Companion_getInstance_13 as Companion_getInstanceltmei8szg1mh,
  Companion_instance_13 as Companion_instance2djixj65v0cw7,
  Companion_instance_7 as Companion_instance1pnby10k4drrs,
  Companion_instance_9 as Companion_instance3gb3zm5gnr6a5,
  Companion_instance_28 as Companion_instance2ro4l92elzn9p,
  Companion_instance_5 as Companion_instanceykgiia56hplq,
  Companion_instance_18 as Companion_instance17kutko0aqeid,
  Companion_instance_19 as Companion_instance2ox6qhwp298su,
  Companion_instance_16 as Companion_instance2l9p65638ljnl,
  Companion_instance_17 as Companion_instance1tkgi2p65guqx,
  Companion_instance_8 as Companion_instance1bxyifpo36xxj,
  Companion_instance_10 as Companion_instance218unjc9ltn4s,
  Companion_instance_20 as Companion_instance1wdeuj7afw8ax,
  Companion_instance_21 as Companion_instancexmfl72rqr3f8,
  Companion_instance_22 as Companion_instance1fynquy6dsj9i,
  Never_getInstance as Never_getInstance32s86skpi7zck,
  Companion_instance_2 as Companion_instance1kshdbaa2euyc,
  Companion_instance_4 as Companion_instance3rhh32thymhrm,
  Companion_instance_6 as Companion_instance1wmugroxx6its,
  Companion_getInstance_26 as Companion_getInstance3i17w8wcrpav1,
  Companion_instance_1 as Companion_instance3kfd7pkebp1l6,
  Companion_getInstance_11 as Companion_getInstancej2hha9qybp58,
  Companion_instance_15 as Companion_instance286iy1cgt2utf,
  Companion_instance_23 as Companion_instance3uymr7onrbkwm,
  Companion_instance_24 as Companion_instance1fklk3p9r3exr,
  Companion_instance_25 as Companion_instance3a5r5sd3blktl,
  Companion_instance_11 as Companion_instance4ohr4qgu4dpv,
};
//endregion

//# sourceMappingURL=Condition.mjs.map
